"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var PaymentPackageEnum;
(function (PaymentPackageEnum) {
    PaymentPackageEnum["DEPOSIT"] = "deposit";
    PaymentPackageEnum["FILESET"] = "fileset";
    PaymentPackageEnum["PER_MINUTE_MESSAGE"] = "per_minute_message";
    PaymentPackageEnum["PER_SENT_MESSAGE"] = "per_sent_message";
    PaymentPackageEnum["SUBSCRIPTION"] = "subscription";
    PaymentPackageEnum["MESSAGE_ATTACHMENT"] = "message_attachment";
    PaymentPackageEnum["PER_MINUTE_CALL"] = "per_minute_call";
})(PaymentPackageEnum = exports.PaymentPackageEnum || (exports.PaymentPackageEnum = {}));
class PaymentPackageProvider extends DataProvider_1.default {
    get fragments() {
        return {
            PaymentPackage: () => `
        ... on PaymentPackage {
          id
          name
          costs {
            ${this.getFragment("CurrencyCost")}
          }
          amount
          type
        }
      `,
            CurrencyCost: () => `
        ... on CurrencyCost {
          cost
          currency
        }
      `,
        };
    }
    findAll({ type }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query PaymentPackageFindAll($type: [String]) {
          paymentPackagesFindAll(type: $type) {
            ${this.getFragment("PaymentPackage")}
          }
        }
      `,
                variables: { type },
            });
            return response.data.paymentPackagesFindAll;
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation PaymentPackageCreate($data: InputPaymentPackageCreate!) {
          paymentPackageCreate(data: $data) {
            ${this.getFragment("PaymentPackage")}
          }
        }
      `,
                variables: { data },
            });
            return response.data.paymentPackageCreate;
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation paymentPackageUpdate($data: InputPaymentPackageUpdate!) {
          paymentPackageUpdate(data: $data) {
            ${this.getFragment("PaymentPackage")}
          }
        }
      `,
                variables: { data },
            });
            return response.data.paymentPackageUpdate;
        });
    }
    delete({ packageId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation PaymentPackageDelete($packageId: ID!) {
          paymentPackageDelete(packageId: $packageId)
        }
      `,
                variables: { packageId },
            });
            return response.data.paymentPackageDelete;
        });
    }
}
exports.PaymentPackageProvider = PaymentPackageProvider;
//# sourceMappingURL=PaymentPackageProvider.js.map